module.exports = __webpack_public_path__ + "static/media/configuration.bd756f4f.svg";